@if (mod) {
<div class="module-view">
  <!-- Sidebar -->
  <aside class="module-sidebar">
    <h6 class="module-sidebar__title">{{ ('Training_Learner.Module_Contents' | translate).replace('%s', moduleIndex + 1) }}</h6>
    <ul class="module-sidebar__list">
      @for (sec of mod.sections; track sec.id; let i = $index) {
        <li class="module-sidebar__item"
            [class.module-sidebar__item--active]="isSectionActive(sec.id)"
            [class.module-sidebar__item--viewed]="isSectionViewed(sec.id)"
            (click)="goToSection(sec.id)">
          <span class="module-sidebar__icon">
            @if (isSectionViewed(sec.id)) {
              <span [innerHTML]="Icons.check | safeHtml"></span>
            } @else {
              {{ i + 1 }}
            }
          </span>
          <span>{{ sec.title }}</span>
        </li>
      }
    </ul>
    <button class="btn btn--small sidebar-quiz-btn"
            [class.btn--primary]="allViewed()"
            [class.btn--ghost]="!allViewed()"
            [disabled]="!allViewed()"
            (click)="goToQuiz()">
      @if (allViewed()) {
        {{ 'Training_Learner.Take_Quiz' | translate }}
      } @else {
        <span [innerHTML]="Icons.lock | safeHtml"></span> {{ 'Training_Learner.View_Sections_First' | translate }}
      }
    </button>
  </aside>

  <!-- Content -->
  <article class="module-content">
    <button class="module-content__back" (click)="goToOverview()">
      <span [innerHTML]="Icons.arrow_left | safeHtml"></span> {{ 'Training_Learner.Back_To_Programme' | translate }}
    </button>

    @if (currentSection) {
      <div class="module-content__header">
        <p class="module-content__module-label">{{ ('Training_Learner.Module_Section_Label' | translate).replace('%m', String(moduleIndex + 1)).replace('%s', String(currentSectionIndex + 1)).replace('%t', String(mod.sections.length)) }}</p>
        <h2 class="module-content__section-title">{{ currentSection.title }}</h2>
      </div>

      <div class="module-content__body" [innerHTML]="currentSection.content | safeHtml"></div>

      <div class="module-content__nav">
        @if (currentSectionIndex > 0) {
          <button class="btn btn--ghost" (click)="goToPrev()">
            <span [innerHTML]="Icons.arrow_left | safeHtml"></span> {{ 'Training_Learner.Previous' | translate }}
          </button>
        } @else {
          <div></div>
        }

        @if (currentSectionIndex < mod.sections.length - 1) {
          <button class="btn btn--primary" (click)="goToNext()">
            {{ 'Training_Learner.Next' | translate }} <span [innerHTML]="Icons.arrow_right | safeHtml"></span>
          </button>
        } @else if (allViewed()) {
          <button class="btn btn--primary" (click)="goToQuiz()">
            {{ 'Training_Learner.Take_Quiz' | translate }} <span [innerHTML]="Icons.arrow_right | safeHtml"></span>
          </button>
        } @else {
          <button class="btn btn--ghost" (click)="goToOverview()">
            {{ 'Training_Learner.Back_To_Overview' | translate }}
          </button>
        }
      </div>
    }
  </article>
</div>
}
